import React, { useContext, useState } from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import "../Pages/Style/dashboard.css";
import "../../App.css";
import "../Pages/Style/billsinvoice.css";
import LogoutCard from '../Components/Card/LogoutCard';
import Footer from '../Components/Footer/Footer';
import TextLinkExample from '../Components/NavBar/NavBar';
import { SidebarContext } from '../../context/SidebarContext';
import SideBar from '../Components/SideBar/SideBar';
import { useCpDetailQuery } from '../../redux/API/FM/CPDetailApi';
import { formatIndianNumber } from '../../Constant/utils';
import { Link } from 'react-router-dom';


const CPDetails = () => {
 const { isSiderbaropen } = useContext(SidebarContext);
const [showLogout, setShowLogout] = useState(false);
const userData = JSON.parse(localStorage.getItem("userData")); 
const userId = userData?.validateEmail[0]?._id;
const {data, isLoading} = useCpDetailQuery(userId)
const [searchQuery, setSearchQuery] = useState("");
const totalInvestment = data?.cpdetail?.reduce((sum, cp) => {
  const investmentSum = cp?.clientdetail?.reduce((acc, client) => acc + (client.totalInvestment || 0), 0);
  return sum + investmentSum;
}, 0);

const totalAUM = data?.cpdetail?.reduce((sum, cp) => {
  const investmentSum = cp?.clientdetail?.reduce((acc, client) => acc + (client.totalAUM || 0), 0);
  return sum + investmentSum;
}, 0);


const filteredData = data?.cpdetail?.filter(cp => 
  cp?.cpinfo?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(cp?.cpinfo?.phone)?.includes(searchQuery) ||
  cp?.cpinfo?.email?.toLowerCase().includes(searchQuery)
);

  return (
    <>
    <div className="App">
        <SideBar />
        <div className={!isSiderbaropen ? "pages" : "pages-change"}>
          <TextLinkExample setShowLogout={setShowLogout} />
          <div className=" BillsInvoice  min-vh-100 ">
            <div className='d-flex justify-content-end mx-4'>
                <div className='position-relative border border-2 border-black-50 ps-2 py-1'>
                <input type="text" className='border-0' placeholder='Search...'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                />
                </div>
            </div>
          <div className="PortfolioReviewHeader mx-4 my-4 py-2 px-2">
            <h4>CP Details</h4>
          </div>
          <div className="BillsInvoiceTable mx-4 overflow-y-hidden ">
              <MDBTable
                hover
                striped
                style={{
                  backgroundColor: "RGB(255 255 255)",
                  fontSize: "12px",
                }}
              >
                <MDBTableHead
                  style={{ backgroundColor: "#5A4344", color: "white" }}
                >
                  <tr>
                    <th scope="col">CP Name</th>
                    <th scope="col">Mobile No.</th>
                    <th scope="col">Email</th>
                    <th scope="col">Total Clients</th>
                    <th scope="col">Total Investment</th>
                    <th scope="col">Total AUA</th>
                    <th scope="col">Revenue Share</th>
                    <th scope="col">View Detail</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  
                    {!isLoading &&
                     filteredData && filteredData?.map((i) => (
                    
                        <tr key={i?._id}>
                          <td>{i?.cpinfo?.name}</td>
                          <td>{i?.cpinfo?.phone}</td>
                          <td>{i?.cpinfo?.email}</td>
                          <td>{i?.clientdetail?.length}</td>
                          <td>{formatIndianNumber(totalInvestment)}</td>
                          <td>{formatIndianNumber(totalAUM)}</td>
                          <td>{`${i?.cpinfo?.cpStdCommision || '00'}%`}</td>
                          <td><Link to={`/FM/cp_details/${i?.cpinfo?._id}`}>view</Link></td>
                        </tr>
                                           
                         ))
                        }
                                      
                      </MDBTableBody>
                      
                       {!isLoading && (data?.cpdetail?.length === 0) && (
                        <MDBTableBody>
                          <tr>
                            <td className="text-center" colSpan={9}>No Record found</td>
                          </tr>
                        </MDBTableBody>
                      )}
              </MDBTable>
            </div>
          </div>
          <Footer/>
          </div>
          </div>
          {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
    </>
  )
}

export default CPDetails